import Script from 'next/script';

type Props = {
  locale: string;
};

const InstagramFeed = ({ locale }: Props) => {
  return (
    <>
      <Script src="https://cdn.lightwidget.com/widgets/lightwidget.js" />
      <iframe
        // eslint-disable-next-line react/no-unknown-property
        allowTransparency={true}
        className="lightwidget-widget"
        scrolling="no"
        src="https://cdn.lightwidget.com/widgets/d2030441efd357ccab339134a778fcf3.html"
        style={{ width: '100%', border: '0', overflow: 'hidden' }}
      ></iframe>
    </>
  );
};

export default InstagramFeed;
